<template>
	<div class="container">
		<div class="content">
			<div class="card mh_700 mb_0">
				<div class="reply_box mb_10">{{ ticketInfo.type_title }}</div>
				<div class="reply_box mb_10">{{ ticketInfo.title }}</div>
				<div class="reply_box type_01 mb_10">
					<p>
						{{ ticketInfo.content }}
					</p>
					<div class="line"></div>
					<p v-if="ticketInfo.reply" class="answer_area">
						<span class="answer_icon"></span>
						{{ ticketInfo.reply }}
					</p>
				</div>
				<div class="button_position">
					<button class="button_bg_red" @click="goList">
						{{ $t('button.list') }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { fetchTicket } from '@/api/cs';
import { commonError } from '@/common/dialog';

export default {
	name: 'InquiryDetail',
	data() {
		return {
			ticketInfo: {},
		};
	},
	created() {
		this.loadTicket();
	},
	methods: {
		goList() {
			this.$router.push({ name: 'user-inquiry_list' });
		},
		async loadTicket() {
			const ticketSeq = this.$route.query.ticket_seq;
			const { ticket_info } = await fetchTicket(ticketSeq).catch(commonError);
			this.ticketInfo = ticket_info;
		},
	},
};
</script>
